<iframe id="webViewerFrame" [src]="urlSafe" allowfullscreen></iframe>
